import { Part } from "../../reducers/models/parts";
import settings from "../../constants/settings";
import useSWR from "swr";
import useSWRFetcher, { SWRFetchError } from "./commonly-stored/fetcher";
import { useEffect, useState } from "react";

export interface UserConsignmentPartDetails {
  part_summary: Part;
  available_inventory_level: number;
}

interface CustomConsignmentPartsResponse {
  parts: UserConsignmentPartDetails[];
  starting_index: number;
  parts_per_page: number;
  total_count: number;
}

export enum PartRequestType {
  CUSTOM = "custom",
  CUSTOM_AND_CONSIGNMENT = "custom and consignment",
}

// null means don't retrieve any parts. undefined means get all users' parts
export default function useCustomConsignmentParts(
  requestType: PartRequestType,
  userId?: string | null,
) {
  const fetcher = useSWRFetcher<CustomConsignmentPartsResponse>();
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [userId]);

  const getUrl = () => {
    if (userId === null) {
      return null;
    } else if (userId === undefined) {
      return `${settings.api_url}/parts/custom?page=${page}`;
    } else if (requestType === PartRequestType.CUSTOM) {
      return `${settings.api_url}/users/${userId}/custom-parts?page=${page}`;
    } else if (requestType === PartRequestType.CUSTOM_AND_CONSIGNMENT) {
      return `${settings.api_url}/users/${userId}/parts?page=${page}`;
    } else {
      return null;
    }
  };

  const {
    data: customConsignmentPartsResponse,
    error,
    isLoading,
    mutate,
  } = useSWR<CustomConsignmentPartsResponse, SWRFetchError>(getUrl(), fetcher);

  return {
    customConsignmentPartsResponse: customConsignmentPartsResponse,
    errored: error !== undefined,
    loading: isLoading,
    fetchParts: () => void mutate(),
    page,
    setPage,
  };
}
